import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import admissionsReducer from "../features/admissionsSlice";
import dataReducer from "../features/dataSlice";
import userReducer from "../features/userSlice";
import dynamicReducer from "../features/dynamicSlice";
import logger from "redux-logger";

const store = configureStore({
  reducer: {
    auth: authReducer,
    admissions: admissionsReducer,
    data: dataReducer,
    user: userReducer,
    dynamic: dynamicReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serialization check
    }),
});

export default store;
